var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9017 5.50041V10.5004L12.9017 12.5004M11.9187 19.4434C10.0366 19.6573 8.13496 19.2719 6.48462 18.3421C4.83427 17.4123 3.51938 15.9855 2.72719 14.2649C1.935 12.5442 1.70591 10.6175 2.07253 8.75907C2.43916 6.90064 3.38281 5.20527 4.7691 3.91439C6.1554 2.62351 7.91365 1.80295 9.79346 1.56956C11.6733 1.33617 13.5788 1.70185 15.2387 2.61453C16.8986 3.5272 18.2282 4.94034 19.0381 6.65269C19.8481 8.36503 20.0971 10.2893 19.7497 12.1514M15.9017 20.5004L20.9017 17.5004L15.9017 14.5004V20.5004Z",
    stroke: "#354052",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioClock);
export default __webpack_public_path__ + "static/media/audio-clock.437e85bc4c8383bc42277bb872d65c62.svg";
export { ForwardRef as ReactComponent };